var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 31,
    fill: "#ECE8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 18C20.4696 18 19.9609 18.2107 19.5858 18.5858C19.2107 18.9609 19 19.4696 19 20C19.0003 20.3508 19.0928 20.6954 19.2683 20.9991C19.4439 21.3028 19.6962 21.5551 20 21.7305V43C19.9981 43.1325 20.0226 43.2641 20.072 43.387C20.1214 43.51 20.1948 43.6219 20.2878 43.7163C20.3809 43.8107 20.4918 43.8856 20.614 43.9368C20.7363 43.9879 20.8675 44.0142 21 44.0142C21.1325 44.0142 21.2637 43.9879 21.386 43.9368C21.5082 43.8856 21.6191 43.8107 21.7122 43.7163C21.8052 43.6219 21.8786 43.51 21.928 43.387C21.9774 43.2641 22.0019 43.1325 22 43V21.7285C22.3035 21.5533 22.5557 21.3014 22.7312 20.998C22.9067 20.6946 22.9994 20.3505 23 20C23 19.4696 22.7893 18.9609 22.4142 18.5858C22.0391 18.2107 21.5304 18 21 18ZM25 22C24.7348 22 24.4805 22.1054 24.2929 22.2929C24.1054 22.4805 24 22.7348 24 23V37C24 37.2652 24.1054 37.5195 24.2929 37.7071C24.4805 37.8946 24.7348 38 25 38H42C42.1752 38.0001 42.3474 37.9542 42.4993 37.8669C42.6512 37.7795 42.7774 37.6538 42.8655 37.5023C42.9535 37.3508 43.0001 37.1788 43.0008 37.0036C43.0014 36.8284 42.956 36.6561 42.8691 36.5039L39.1523 30L42.8691 23.4961C42.956 23.3439 43.0014 23.1716 43.0008 22.9964C43.0001 22.8212 42.9535 22.6492 42.8655 22.4977C42.7774 22.3462 42.6512 22.2205 42.4993 22.1331C42.3474 22.0458 42.1752 21.9999 42 22H25ZM26 24H32V36H26V24Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 31.0004,
    y1: 18,
    x2: 31.0004,
    y2: 44.0142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A35EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6023E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.293fba04395d6232189f3a5525a9b50c.svg";
export { ForwardRef as ReactComponent };